import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  ITrackingAction,
  ITrackingProperties,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const TOGGLE_I2G_MONEY_DIALOG_TYPE = 'toggle-i2g-money-method-dialog';
export const TOGGLE_CARD_PAYMENTS_DIALOG_TYPE =
  'toggle-card-payments-method-dialog';
export const TOGGLE_PAYPAL_DIALOG_TYPE = 'toggle-paypal-method-dialog';
export const TOGGLE_DIRECT_TRANSFER_DIALOG_TYPE =
  'toggle-direct-transfer-method-dialog';

@Component({
  selector: 'app-toggle-payment-method-dialog',
  styleUrls: ['toggle-payment-method-dialog.component.scss'],
  templateUrl: 'toggle-payment-method-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TogglePaymentMethodDialogComponent {
  @Input() dialogType: string;
  @Input() text: string;
  @Input() primaryActionText: string;
  @Input() secondaryActionText: string;

  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() primaryActionTapped: ITrackingAction;
  @Input() secondaryActionTapped: ITrackingAction;
  @Input() dismissActionTapped: ITrackingAction;

  @Input() trackingDialogName: TrackingDialogNamesEnum;
  @Input() primaryActionTrackingAdditionalProperties: ITrackingProperties;
  @Input() secondaryActionTrackingAdditionalProperties: ITrackingProperties;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  @Output() primaryAction: EventEmitter<void> = new EventEmitter();
  @Output() secondaryAction: EventEmitter<void> = new EventEmitter();
}
